import { formatString } from "./formatString";

export const formatEIN = (ein: string) => {
  return formatString(ein, "##-#######");
};